import { styled } from '@mui/material';

// import { QuoteSection, type QuoteSectionProps } from './_sections/QuoteSection.tsx';
import { competitionWinnersQuery } from '@/lib/api/requests.ts';
import { getQueryClient } from '@/lib/query-client-context.ts';

import Page from '../../../../../components/Page/index.ts';

import type { Route } from './+types/LandingPageJuly';
// import madsHansen from './_assets/mads-hansen.webp';
import { Footer } from './_sections/Footer.tsx';
import { RulesSection } from './_sections/RulesSection.tsx';
import { StatsSection } from './_sections/StatsSection.tsx';
import { TimerSectionJuly } from './_sections/TimerSectionJuly.tsx';
import { TopSectionJuly } from './_sections/TopSectionJuly.tsx';
import { WinnersSection } from './_sections/WinnersSection.tsx';

const Root = styled('div')({
  width: '100%',
  backgroundColor: 'white',
});

// const quote: QuoteSectionProps = {
//   photo: madsHansen,
//   photoAlt: 'Mads Hansen (34)',
//   photoCaption: 'Foto: Knut Berg Jenssen / Dagbladet',
//   quote:
//     '- Hehe, ja. Da jeg skjønte at jeg hadde blitt trukket ut i maitrekningen og at Scoopr faktisk kom til å betale ned hele forbruksgjelden min, da stokket ordene seg for meg. Det var som vi sier her i Tromsø - jævlig artig!',
//   quoteCaption:
//     'Sier Mads Hansen (34), vinner av Mai-trekningen, til Dagbladet',
// };

export async function loader({ context }: Route.LoaderArgs) {
  const queryClient = getQueryClient(context);
  const competitions = await queryClient.query(competitionWinnersQuery());
  const competition = competitions.find((c) => c.slug === 'summer_2024_campaign_2');
  return {
    winners: competition?.winners,
  };
}

export default function LandingPage({ loaderData }: Route.ComponentProps) {
  return (
    <Page title="Sommerkampanje">
      <Root>
        <TopSectionJuly winners={loaderData.winners} />
        <TimerSectionJuly />
        <WinnersSection winners={loaderData.winners} month="juli" />
        {/* <QuoteSection {...quote} /> */}
        <RulesSection />
        <StatsSection />
        <Footer />
      </Root>
    </Page>
  );
}
